import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { getUserInfo, clearAuth as apiClearAuth } from '@/api'

export const useAuthStore = defineStore('auth', () => {
  // State
  const sessionUuid = ref(localStorage.getItem('sessionUuid'))
  const role = ref(localStorage.getItem('role'))
  const username = ref(localStorage.getItem('username'))
  const uuid = ref(localStorage.getItem('uuid'))
  const describe = ref(localStorage.getItem('describe'))
  const upload = ref(Number(localStorage.getItem('upload')) || 0)
  const download = ref(Number(localStorage.getItem('download')) || 0)
  const total = ref(Number(localStorage.getItem('total')) || 0)

  // Getters
  const isAuthenticated = computed(() => !!sessionUuid.value)
  const subscriptionUrl = computed(() => {
    if (!uuid.value) return ''
    const apiBaseUrl = process.env.VUE_APP_API_URL || ''
    return `${apiBaseUrl}/api/subscribe?OwO=${uuid.value}`
  })
  const clashProtocolUrl = computed(() => {
    if (!subscriptionUrl.value || !username.value) return ''
    return `clash://install-config?url=${encodeURIComponent(subscriptionUrl.value)}&flag=meta&name=${username.value}`
  })

  // Actions
  const setAuth = (data) => {
    sessionUuid.value = data.sessionUuid
    role.value = data.role
    username.value = data.username

    localStorage.setItem('sessionUuid', data.sessionUuid)
    localStorage.setItem('role', data.role)
    localStorage.setItem('username', data.username)
  }

  const setUserInfo = (data) => {
    uuid.value = data.uuid
    describe.value = data.describe
    upload.value = Number(data.upload) || 0
    download.value = Number(data.download) || 0
    total.value = Number(data.total) || 0

    localStorage.setItem('uuid', data.uuid)
    localStorage.setItem('describe', data.describe)
    localStorage.setItem('upload', String(upload.value))
    localStorage.setItem('download', String(download.value))
    localStorage.setItem('total', String(total.value))
  }

  const fetchUserInfo = async () => {
    try {
      const info = await getUserInfo()
      setUserInfo({
        uuid: info.uuid,
        describe: info.describe,
        upload: info.upload,
        download: info.download,
        total: info.total
      })
    } catch (error) {
      console.error('Failed to fetch user info:', error)
      throw error
    }
  }

  const logout = () => {
    sessionUuid.value = null
    role.value = null
    username.value = null
    uuid.value = null
    describe.value = null
    upload.value = 0
    download.value = 0
    total.value = 0

    apiClearAuth()
  }

  return {
    // State
    sessionUuid,
    role,
    username,
    uuid,
    describe,
    upload,
    download,
    total,
    // Getters
    isAuthenticated,
    subscriptionUrl,
    clashProtocolUrl,
    // Actions
    setAuth,
    setUserInfo,
    fetchUserInfo,
    logout
  }
}, {
  persist: true
})
